import React , {useState,useEffect} from 'react';
import Chart from 'react-apexcharts'

const StudentListYearLevel =(props)=>{
  const { studentCountYearLevel } = props;
  const formatData=(chartObj)=>{
    const data = []
    Object.keys(chartObj.data).forEach(obj=>{
      data.push({
        name: obj,
        data: chartObj.data[`${obj}`]
      })
    })
    const labels = chartObj.years.filter(obj=> parseInt(obj))
      return {
        series: data,
        options: {
        colors:['#36b7b2', '#1498cf', '#f26189','#9a52a3'],
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
          },
          plotOptions: {
            bar: {
              horizontal: true,
            },
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          title: {
            text: "Students Joined ",
          },
          xaxis: {
            categories: labels,
            labels: {
              formatter: function (val) {
                return parseInt(val);
              },
            },
          },
          yaxis: {
            title: {
              text: undefined,
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return parseInt(val);
              },
            },
          },
          fill: {
            opacity: 1,
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      };
  }
  const [chartData, setChartData] = useState(formatData(studentCountYearLevel));
  useEffect(() => {
    setChartData(formatData(studentCountYearLevel))
  }, [studentCountYearLevel])
  return (
    <div id="chart">
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={350}
      />
    </div>
  );
}
export default StudentListYearLevel
